// Firm Roles
const ROLE_COMPLIANCE = 'Compliance'
const ROLE_NORMAL = 'Normal'

export const FIRM_ROLE = {
  ROLE_COMPLIANCE,
  ROLE_NORMAL,
}

// Group Roles
const ROLE_CAPTAIN = 'Captain'
const ROLE_MANAGER = 'Manager'
const ROLE_CONTRIBUTOR = 'Contributor'

export const GROUP_ROLE = {
  ROLE_CAPTAIN,
  ROLE_MANAGER,
  ROLE_CONTRIBUTOR,
}

// Internal Roles
const ROLE_MASTER = 'Master'
const ROLE_ADMIN = 'Admin'
const ROLE_VIEWONLY = 'SuperViewer'

export const INTERNAL_ROLE = {
  ROLE_MASTER,
  ROLE_ADMIN,
  ROLE_NORMAL,
  ROLE_VIEWONLY,
}
